import { DictCodeEnmu } from "./AppDictEnums"
import { messageInformModeEnum, messageInformPeriodEnum, messageStatusEnum } from "./AppEnums"


//消息提醒类型
export const messageStatusDs = [
	{
		label: "未读",
		value: messageStatusEnum.MESSAGE_INIT
	},
	{
		label: "已读",
		value: messageStatusEnum.MESSAGE_READ
	},
	{
		label: "完成",
		value: messageStatusEnum.MESSAGE_END
	},
]

//消息提醒次数
export const messageInformPeriodDs = [
	{
		label: "一次",
		value: messageInformPeriodEnum.INFORMPERIOD_ONE
	},
	{
		label: "多次",
		value: messageInformPeriodEnum.INFORMPERIOD_MORE
	},
]

//消息提醒类型
export const messageInformModeDs = [
	{
		label: "短信",
		value: messageInformModeEnum.INFORMMODE_SMS
	},
	{
		label: "公众号",
		value: messageInformModeEnum.INFORMMODE_OFFICIALACCOUNT
	},
	{
		label: "站内",
		value: messageInformModeEnum.INFORMMODE_INSTATION
	},
]